import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c6aca58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "app-container" }
const _hoisted_3 = { class: "app-header" }
const _hoisted_4 = { class: "app-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_head = _resolveComponent("top-head")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_top_head)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}